<template>
  <h1></h1>
</template>

<script>
import {APK_DOWNLOAD} from "@/public/state";
export default {
    metaInfo: {
        title: 'Download',
        // meta: [
        //   {
        //     name: 'keywords',
        //     content: '关键字1,关键字2,关键字3'
        //   },
        //   {
        //     name: 'description',
        //     content: '这是一段网页的描述'
        //   }
        // ]
    },
    created(){
      var a = document.createElement("a");
      a.href= APK_DOWNLOAD;
      a.download="Cicadasing.apk";
      a.click();
      setTimeout(()=>{
        location.href="https://play.google.com/store/apps/details?id=com.chirping";
      },500)
    }
}
</script>